module.exports = __webpack_public_path__ + "img/female-teenager-hand.087e4948.svg";